module.exports = __webpack_public_path__ + "0d5c26e637b6cd7ff49166e1afb9546d.MP3";